import { useEffect, useState } from 'react';
import { clientConfig } from '../utilities/configService';


export const useClientStyleSheet = () => {
    const [styleSheet, setStyleSheet] = useState('Fleet Electrification (not from Dato)');

    const applicationName = clientConfig?.APPLICATION_NAME || '';

    useEffect(() => {
        if (applicationName) {
            var url = "/client-css/" + applicationName.toLowerCase() + "-vars.css"
            const style = document.createElement("link");
            style.href = url;
            style.rel = "stylesheet";
            document.head.appendChild(style);
        }
    }, []);

    return [styleSheet, setStyleSheet];
}